import Vue from 'vue'
import Vuex from 'vuex'
import datas from '@/store/modules/datas'

Vue.use(Vuex)

export default new Vuex.Store({
  // state: {
  // },
  // mutations: {
  // },
  // actions: {
  // },
  modules: {
    datas
  }
})
